import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

// manor_backend/middleware reads "<sessionId>&<organizationId>" from the Bearer token.
const config = (s) => ({ headers: { Authorization: `Bearer ${s.sessionId}&${s.organizationId}` } });

const post = (path, s, extra = {}) => api.post(path, { ...s, ...extra }, config(s)).then((r) => r.data);

export const fetchManorState = (s) => post('/manor/state', s);
export const startManor = (s) => post('/manor/start', s);
export const submitManorStage = (s, round, points) => post('/manor/submit', s, { round, points });
export const linkManorReport = (s, reportId) => post('/manor/linkReport', s, { reportId });
